import {IColumnItem, IExportStyles} from "@ui/tableCustom/types/columns";
import {MERGE_CELL_EMPTY_COLUMN} from "../constants";

const buildExportStyles = (exportStyles: IExportStyles, type: 'rowSpan' | 'colSpan'): IExportStyles => {
    if (!exportStyles?.excel) {
        return
    }
    if (type !== 'rowSpan') {
        return exportStyles;
    }

    return {
        ...exportStyles,
        excel: {
            ...exportStyles.excel,
            border: {
                ...(exportStyles.excel?.border ?? {}),
                top: null
            }
        }
    }
}
export const buildEmptyCell = <T>(column: IColumnItem<T>, type: 'rowSpan' | 'colSpan') => {
    if (!column) {
        return MERGE_CELL_EMPTY_COLUMN
    }
    const exportStyles = buildExportStyles(column.exportStyles, type)
    const exportStylesHeader = buildExportStyles(column.exportStylesHeader, type)
    return {
        ...MERGE_CELL_EMPTY_COLUMN,
        exportStyles,
        exportStylesHeader
    }
}